<!-- <p>incident-dashboard works!</p> -->
<!-- <div class="data-not-found">Coming Soon...</div> -->
<section *ngIf="!incidentData.flows.isIncidentManualEvent">
  <mat-card class="incident-dashboard-card">
    <mat-card-content class="incident-dashboard-card-content">
      <mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'15px'">
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL TODAY</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!incidentData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{ todaysIncidentCount }}
              </div>
              <div *ngIf="incidentData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">visibility</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >OPEN TODAY</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!incidentData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{ todaysOpenIncidentCount }}
              </div>
              <div *ngIf="incidentData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <i class="fa-solid fa-circle-exclamation counter-icon"></i>
            </mat-card-content> </mat-card
        ></mat-grid-tile>
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >CLOSED TODAY</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!incidentData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{ todaysCloseIncidentCount }}
              </div>
              <div *ngIf="incidentData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">verified_user</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
      </mat-grid-list>
      <mat-divider></mat-divider>
      <mat-grid-list cols="3" rowHeight="150px" [gutterSize]="'15px'">
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL INCIDENTS</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!incidentData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  incidentData.incidentDetails.totalIncidents
                    ? incidentData.incidentDetails.totalIncidents
                    : 0
                }}
              </div>
              <div *ngIf="incidentData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">visibility</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL OPEN</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!incidentData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  incidentData.incidentDetails.totalOpen
                    ? incidentData.incidentDetails.totalOpen
                    : 0
                }}
              </div>
              <div *ngIf="incidentData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <i class="fa-solid fa-circle-exclamation counter-icon"></i>
            </mat-card-content> </mat-card
        ></mat-grid-tile>
        <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
          ><mat-card class="incident-counter-card"
            ><mat-card-header class="incident-counter-card-header"
              >TOTAL CLOSED</mat-card-header
            >
            <mat-card-content class="incident-counter-card-content">
              <div
                *ngIf="!incidentData.status.isFetchingAPIRequest"
                class="counter-text"
              >
                {{
                  incidentData.incidentDetails.totalClosed
                    ? incidentData.incidentDetails.totalClosed
                    : 0
                }}
              </div>
              <div *ngIf="incidentData.status.isFetchingAPIRequest">
                <mat-spinner diameter="55"></mat-spinner>
              </div>
              <mat-icon class="counter-icon">verified_user</mat-icon>
            </mat-card-content>
          </mat-card></mat-grid-tile
        >
      </mat-grid-list>
      <mat-divider></mat-divider>
      <div class="search-filter-wrapper">
        <mat-grid-list cols="3" rowHeight="100px" [gutterSize]="'15px'">
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1">
            <div class="mat-inside-grid-tile">
              <mat-form-field subscriptSizing="dynamic" appearance="outline">
                <mat-label>Enter Start and End Date</mat-label>
                <mat-date-range-input
                  [formGroup]="range"
                  [rangePicker]="picker"
                >
                  <input
                    matStartDate
                    formControlName="start"
                    placeholder="Start date"
                  />
                  <input
                    matEndDate
                    formControlName="end"
                    [min]="currentDate"
                    placeholder="End date"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                @if (range.controls.start.hasError('matStartDateInvalid')) {
                <mat-error>Invalid start date</mat-error>
                } @if (range.controls.end.hasError('matEndDateInvalid')) {
                <mat-error>Invalid end date</mat-error>
                }
              </mat-form-field>
              <!-- range.controls.end.value != null &&
              range.controls.start.value != null -->
              <button
                *ngIf="isClickedSubmit"
                mat-icon-button
                (click)="onGetResetData()"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="screenSize != ScreenType.Mobile"
            [colspan]="1"
          ></mat-grid-tile>
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1">
            <div class="button-inside-grid-tile">
              <button
                [disabled]="
                  !(
                    range.controls.end.value != null &&
                    range.controls.start.value != null
                  )
                "
                (click)="onGetRangeData()"
                mat-raised-button
              >
                Submit
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </div>

      <mat-divider></mat-divider>
      <div *ngIf="!isLoggedInUser">
        <mat-grid-list cols="3" [gutterSize]="'15px'" rowHeight="600px">
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 3"
            ><mat-card class="incident-charts-card"
              ><mat-card-header class="incident-counter-card-header"
                >INCIDENT BREAKDOWN</mat-card-header
              >
              <mat-card-content class="incident-charts-card-content">
                <app-incident-breakdown
                  [breakdownIncidentData]="
                    incidentData.incidentDetails.breakdownGraphData
                  "
                ></app-incident-breakdown>
              </mat-card-content> </mat-card
          ></mat-grid-tile>
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 2"
            ><mat-card class="incident-charts-card"
              ><mat-card-header class="incident-counter-card-header"
                >INCIDENT STATUS</mat-card-header
              >
              <mat-card-content class="incident-charts-card-content">
                <app-incident-status-graph
                  [graphIncidentData]="
                    incidentData.incidentDetails.incidentGraphCounts
                  "
                  (statusClicked)="onStatusClicked($event)"
                ></app-incident-status-graph>
              </mat-card-content> </mat-card
          ></mat-grid-tile>
          <mat-grid-tile [colspan]="screenSize == ScreenType.Mobile ? 3 : 1"
            ><mat-card class="incident-charts-card"
              ><mat-card-header class="incident-counter-card-header"
                >TOP CATEGORIES</mat-card-header
              >
              <mat-card-content class="incident-charts-card-content">
                <app-incident-categories
                  [chartData]="incidentGraphData"
                ></app-incident-categories>
              </mat-card-content> </mat-card
          ></mat-grid-tile>
        </mat-grid-list>
        <mat-divider></mat-divider>
      </div>

      <mat-grid-list
        style="margin: 10px 0 10px 0"
        cols="3"
        rowHeight="90px"
        [gutterSize]="'10px'"
      >
        <mat-grid-tile
          *ngIf="
            (!isShowIncidentDetail &&
              screenSize == ScreenType.Mobile &&
              false) ||
            (screenSize != ScreenType.Mobile && false)
          "
          colspan="3"
          [rowspan]="
            securityCallbackIncidents?.length < 3
              ? 3
              : securityCallbackIncidents?.length <= 5
              ? 5
              : securityCallbackIncidents?.length < 8
              ? 7
              : 8
          "
        >
          <mat-card class="incident-table-card">
            <mat-card-content class="incident-table-card-content">
              <app-incident-security-callback
                [incidentTableData]="securityCallbackIncidents"
                (initCreateManualEvent)="onInitCreateManualEvent()"
                (verifyIncident)="onVerifyIncident($event)"
                [isIncidentDetailsClosed]="isShowIncidentDetail"
                (showIncidentDetail)="onShowVisitorDetail($event)"
                (refreshIncidentData)="onRefreshIncidentData()"
              ></app-incident-security-callback>
            </mat-card-content>
            <br />
            <mat-divider></mat-divider>
          </mat-card>
        </mat-grid-tile>
        <!-- <mat-grid-tile
          *ngIf="
            (!isShowIncidentDetail &&
              screenSize == ScreenType.Mobile &&
              false) ||
            (screenSize != ScreenType.Mobile && false)
          "
          colspan="3"
          [rowspan]="
            incidentData.incidentDetails?.incidentList?.length < 5
              ? 5
              : incidentData.incidentDetails?.incidentList?.length < 8
              ? 7
              : 8
          "
        >
          <mat-card class="incident-table-card">
            <mat-card-content class="incident-table-card-content">
              <app-incident-dashboard-table
                [incidentTableData]="incidentData.incidentDetails.incidentList"
                (initCreateManualEvent)="onInitCreateManualEvent()"
                (verifyIncident)="onVerifyIncident($event)"
                [isIncidentDetailsClosed]="isShowIncidentDetail"
                (showIncidentDetail)="onShowVisitorDetail($event)"
                (refreshIncidentData)="onRefreshIncidentData()"
              ></app-incident-dashboard-table>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile> -->
        <mat-grid-tile
          style="overflow: hidden"
          colspan="3"
          [rowspan]="
            securityCallbackIncidents.length > 5
              ? 7
              : securityCallbackIncidents.length == 3
              ? 6
              : 5
          "
          *ngIf="
            (!isShowIncidentDetail && screenSize == ScreenType.Mobile) ||
            screenSize != ScreenType.Mobile
          "
        >
          <div class="div-inside-grid-tile">
            <mat-tab-group
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              #incidentTabs
              (selectedTabChange)="onChangeSelection($event)"
            >
              <mat-tab label="Critical Risk">
                <mat-card class="incident-table-card">
                  <mat-card-content class="incident-table-card-content">
                    <app-incident-dashboard-table
                      [incidentTableData]="
                        incidentData.incidentDetails.criticalIncidentList
                      "
                      (initCreateManualEvent)="onInitCreateManualEvent()"
                      (verifyIncident)="onVerifyIncident($event)"
                      [isIncidentDetailsClosed]="isShowIncidentDetail"
                      (showIncidentDetail)="onShowVisitorDetail($event)"
                      (refreshIncidentData)="onRefreshIncidentData()"
                      (snoozeIncident)="onSnoozeIncident($event)"
                    ></app-incident-dashboard-table>
                  </mat-card-content> </mat-card
              ></mat-tab>
              <mat-tab label="Medium Risk"
                ><mat-card class="incident-table-card">
                  <mat-card-content class="incident-table-card-content">
                    <app-incident-dashboard-table
                      [incidentTableData]="
                        incidentData.incidentDetails.mediumIncidentList
                      "
                      (initCreateManualEvent)="onInitCreateManualEvent()"
                      (verifyIncident)="onVerifyIncident($event)"
                      [isIncidentDetailsClosed]="isShowIncidentDetail"
                      (showIncidentDetail)="onShowVisitorDetail($event)"
                      (refreshIncidentData)="onRefreshIncidentData()"
                      (snoozeIncident)="onSnoozeIncident($event)"
                    ></app-incident-dashboard-table>
                  </mat-card-content>
                  <br />
                  <mat-divider></mat-divider>
                </mat-card>
              </mat-tab>
              <mat-tab label="Low Risk">
                <mat-card class="incident-table-card">
                  <mat-card-content class="incident-table-card-content">
                    <app-incident-dashboard-table
                      [incidentTableData]="
                        incidentData.incidentDetails.lowIncidentList
                      "
                      (initCreateManualEvent)="onInitCreateManualEvent()"
                      (verifyIncident)="onVerifyIncident($event)"
                      [isIncidentDetailsClosed]="isShowIncidentDetail"
                      (showIncidentDetail)="onShowVisitorDetail($event)"
                      (refreshIncidentData)="onRefreshIncidentData()"
                      (snoozeIncident)="onSnoozeIncident($event)"
                    ></app-incident-dashboard-table>
                  </mat-card-content>
                </mat-card>
              </mat-tab>
              <mat-tab label="No Risk">
                <mat-card class="incident-table-card">
                  <mat-card-content class="incident-table-card-content">
                    <app-incident-dashboard-table
                      [incidentTableData]="
                        incidentData.incidentDetails.noIncidentList
                      "
                      (initCreateManualEvent)="onInitCreateManualEvent()"
                      (verifyIncident)="onVerifyIncident($event)"
                      [isIncidentDetailsClosed]="isShowIncidentDetail"
                      (showIncidentDetail)="onShowVisitorDetail($event)"
                      (refreshIncidentData)="onRefreshIncidentData()"
                      (snoozeIncident)="onSnoozeIncident($event)"
                    ></app-incident-dashboard-table>
                  </mat-card-content>
                </mat-card>
              </mat-tab>
              <mat-tab label="Recent Activity">
                <mat-card class="incident-table-card">
                  <mat-card-content class="incident-table-card-content">
                    <app-incident-dashboard-table
                      [incidentTableData]="
                        incidentData.incidentDetails.recentActivityIncidentList
                      "
                      (initCreateManualEvent)="onInitCreateManualEvent()"
                      (verifyIncident)="onVerifyIncident($event)"
                      [isIncidentDetailsClosed]="isShowIncidentDetail"
                      (showIncidentDetail)="onShowVisitorDetail($event)"
                      (refreshIncidentData)="onRefreshIncidentData()"
                      (snoozeIncident)="onSnoozeIncident($event)"
                    ></app-incident-dashboard-table>
                  </mat-card-content>
                </mat-card>
              </mat-tab>
            </mat-tab-group>
          </div>
        </mat-grid-tile>

        <mat-grid-tile
          *ngIf="isShowIncidentDetail"
          colspan="3"
          [rowspan]="screenSize == ScreenType.Mobile ? 28 : 12"
        >
          <mat-card class="incident-table-card scroll-to-incident-details">
            <mat-card-content class="incident-table-card-content">
              <app-incident-detail
                [incidentDetails]="incidentDetails"
                (closeIncidentDetail)="onCloseIncidentDetail()"
                (snoozeIncident)="onSnoozeIncident($event)"
                (showTimeline)="onShowTimeline($event)"
                (postIncidentComment)="onPostIncidentComment($event)"
                [orgUser]="incidentData.orgUserList"
                [OrgAssets]="incidentData.orgAssetList.assets"
              ></app-incident-detail>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="
            isShowIncidentTimline &&
            (isFaceIncident || isANPRIncident) &&
            isShowIncidentDetail
          "
          colspan="3"
          rowspan="6"
          ><div class="incident-timeline-card">
            <mat-card>
              <mat-card-content class="incident-table-card-content">
                <app-face-timeline-table
                  [incidentTableData]="incidentDetails"
                ></app-face-timeline-table>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="isShowIncidentDetail && false"
          colspan="3"
          rowspan="4"
          ><div class="incident-timeline-card">
            <mat-card style="height: calc(100% - 10px)">
              <mat-card-content class="incident-table-card-content">
                <app-incidents-timeline-graph-container
                  [incidentData]="incidentDetails"
                  [orgUsersData]="incidentData.orgUserList"
                  [isGraph]="true"
                  (closeIncidentDetail)="onCloseIncidentDetail()"
                ></app-incidents-timeline-graph-container>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-grid-tile>
        <mat-grid-tile
          *ngIf="isShowIncidentDetail && false"
          colspan="3"
          rowspan="4"
          ><div class="incident-timeline-card">
            <mat-card style="height: calc(100% - 10px)">
              <mat-card-content class="incident-table-card-content">
                <app-incidents-timeline-graph-container
                  [incidentData]="incidentDetails"
                  [orgUsersData]="incidentData.orgUserList"
                  [isGraph]="false"
                  (closeIncidentDetail)="onCloseIncidentDetail()"
                  (postIncidentComment)="onPostIncidentComment($event)"
                ></app-incidents-timeline-graph-container>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>
  </mat-card>
</section>
<!-- Create Manual Event -->
<div
  *ngIf="incidentData.flows.isIncidentManualEvent && !isCloseDisplay"
  class="close-button"
>
  <!-- <button (click)="onClose()" mat-raised-button>Close</button> //Remove this -->
</div>
<section *ngIf="incidentData.flows.isIncidentManualEvent">
  <div
    *ngIf="incidentData.status.isFetchingAPIRequest"
    style="width: calc(100% - 15px)"
    class="loading-spinner"
  >
    <mat-spinner></mat-spinner>
  </div>
  <section>
    <div
      class=""
      [ngClass]="{
        'incident-gate-entry-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'incident-gate-entry-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      New Incident &#64;{{ timeNow | date : "medium" }}
    </div>
    <mat-divider></mat-divider>
    <div class="incident-gate-entry-form">
      <form [formGroup]="incidentManualEvent">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
          rowHeight="80px"
          gutterSize="25px"
        >
          <mat-grid-tile rowspan="4">
            <div class="upload-manual-event-evidence">
              <div class="event-evidence-image-container">
                <div class="spinner-evidence" *ngIf="isFetching">
                  <mat-spinner></mat-spinner>
                </div>
                <div *ngIf="isCamera" class="back-button-wrapper">
                  <button mat-mini-fab (click)="onBack()">
                    <mat-icon>arrow_back</mat-icon>
                  </button>
                </div>

                <img
                  *ngIf="!isShowAssetFrame && !showWebcam"
                  [src]="eventEvidence"
                  alt="Upload evidence"
                />
                <div *ngIf="showWebcam">
                  <webcam
                    [trigger]="invokeObservable"
                    [switchCamera]="nextWebcamObservable"
                    (imageCapture)="captureImg($event)"
                    [width]="screenSize == ScreenType.Mobile ? 280 : 320"
                    [height]="screenSize == ScreenType.Mobile ? 300 : 320"
                  ></webcam>
                </div>
                <iframe
                  *ngIf="isShowAssetFrame && !isFetching"
                  #iframeElement
                  [height]="300"
                  [width]="280"
                  [src]="src | safe"
                  frameborder="0"
                  crossorigin="*"
                  allowfullscreen
                >
                </iframe>
              </div>
              <div *ngIf="!isShowAssetFrame" class="upload-evidence-button">
                <div *ngIf="!isCamera">
                  <label for="evidencepic" class="upload-button-label"
                    >Upload</label
                  >
                  <input
                    style="display: none"
                    id="evidencepic"
                    (change)="onUploadEvidence($event)"
                    type="file"
                    name=""
                    accept="image/*"
                  />
                </div>
                <div *ngIf="isCamera">
                  <mat-form-field
                    style="width: 200px"
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Select Camera</mat-label>
                    <mat-select
                      [value]="deviceSelected"
                      (valueChange)="onDeviceSelectChange($event)"
                    >
                      <mat-option
                        *ngFor="let device of availableDevices"
                        [value]="device.deviceId"
                        >{{ device.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="!isCamera" style="height: 48px">
                  <button (click)="onClickOpenCamera()" mat-raised-button>
                    {{ "Click" }}
                  </button>
                </div>
                <div *ngIf="isCamera" style="height: 48px">
                  <button (click)="getSnapshot()" mat-raised-button>
                    {{
                      showWebcam || !isDeviceSelected ? "Capture" : "ReCapture"
                    }}
                  </button>
                </div>
              </div>
              <div
                *ngIf="isShowAssetFrame"
                class="snapshot-button"
                (click)="takeASnapshot()"
              >
                <button [disabled]="isFetching" mat-raised-button>
                  Take a snapshot
                </button>
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Incident Type</mat-label>
              <mat-select formControlName="incidentType">
                <mat-option value="manual">Manual </mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <!-- <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Incident Name</mat-label>
              <mat-select formControlName="incidentName">
                <mat-option
                  *ngFor="let incidentType of incidentOptions"
                  [value]="incidentType"
                  >{{ incidentType }}
                </mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          > -->
          <mat-grid-tile>
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Incident Name</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="auto"
                [formControl]="incidentNameControl"
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let incidentType of filteredIncidentOptions"
                  [value]="incidentType"
                >
                  {{ incidentType }}
                </mat-option>
              </mat-autocomplete>
              <!-- <mat-error *ngIf="incidentNameControl?.hasError('invalidOption')">
                Please select a valid incident name.
              </mat-error> -->
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile rowspan="2">
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Incident Description</mat-label>
              <textarea
                matInput
                formControlName="incidentDescription"
                rows="5"
              ></textarea>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="viewIncident != null"
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Location Reference</mat-label>
              <input
                readonly
                matInput
                [value]="viewIncident"
              /> </mat-form-field
          ></mat-grid-tile>
          <!-- <mat-grid-tile *ngIf="viewIncident == null"
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Location Reference</mat-label>
              <input
                matInput
                formControlName="incidentLocation"
              /> </mat-form-field
          ></mat-grid-tile> -->
          <mat-grid-tile *ngIf="!isNative"
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Source</mat-label>
              <mat-select
                (selectionChange)="onChangeSourceSelection($event)"
                formControlName="sourceAssetId"
              >
                <mat-option
                  *ngFor="
                    let asset of incidentData.orgAssetList.assets;
                    let i = index
                  "
                  [value]="asset.assetId"
                  >{{ asset.assetName | titlecase }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select formControlName="incidentStatus">
                <mat-option value="0">Open</mat-option>
                <!-- <mat-option value="1">Close</mat-option>
                <mat-option value="2">Verified</mat-option>
                <mat-option value="3">Snooze</mat-option>
                <mat-option value="4">In-progress</mat-option>
                <mat-option value="5">On-hold</mat-option>
                <mat-option value="6">Approved</mat-option>
                <mat-option value="7">Rejected</mat-option> -->
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Priority</mat-label>
              <mat-select formControlName="incidentCriticality">
                <mat-option value="High">High</mat-option>
                <mat-option value="Medium">Medium</mat-option>
                <mat-option value="Low">Low</mat-option>
              </mat-select>
            </mat-form-field></mat-grid-tile
          >
          <mat-grid-tile>
            <div class="reporter-field-container">
              <div class="checkbox-container">
                <mat-checkbox
                  (change)="onCheckTrue($event)"
                  class="reporter-margin"
                  formControlName="isCheckedReporter"
                >
                </mat-checkbox>
              </div>
              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>Reporter*</mat-label>
                <input
                  *ngIf="
                    !incidentManualEvent.controls['isCheckedReporter'].value
                  "
                  matInput
                  formControlName="eventCreatedBy"
                />
                <input
                  *ngIf="
                    incidentManualEvent.controls['isCheckedReporter'].value
                  "
                  matInput
                  [formControl]="reporterControl"
                  [matAutocomplete]="autoReporter"
                />
                <mat-autocomplete
                  (optionSelected)="addReporter($event)"
                  #autoReporter="matAutocomplete"
                >
                  <mat-option
                    *ngFor="let host of filteredReporter"
                    [value]="host.firstname + ' ' + host.lastname"
                  >
                    <img
                      class="visitor-img"
                      [src]="host.profilePicture"
                      height="30"
                      width="36"
                    />
                    <span> {{ host.firstname + " " + host.lastname }}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Select Assign*</mat-label>
              <input
                matInput
                [formControl]="selectedUsersControl"
                [matAutocomplete]="autoAdmin"
              />
              <mat-icon
                style="background-color: transparent; color: #e93578"
                matSuffix
                (click)="clearInputField()"
                >clear</mat-icon
              >
              <mat-autocomplete
                (optionSelected)="addUser($event)"
                #autoAdmin="matAutocomplete"
              >
                <mat-option
                  *ngFor="let host of filteredAssignee"
                  [value]="host.firstname + ' ' + host.lastname"
                >
                  <img
                    class="visitor-img"
                    [src]="host.profilePicture"
                    height="30"
                    width="36"
                  />
                  <span> {{ host.firstname + " " + host.lastname }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="usersTemp.length > 0">
            <div class="selected-users">
              <mat-chip
                *ngFor="let user of usersTemp"
                [removable]="true"
                (removed)="removeUser(user)"
              >
                {{ user }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </div>
          </mat-grid-tile>
          <!-- <mat-grid-tile>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Tag Name</mat-label>
              <input
                matInput
                formControlName="eventOwnerName"
              />
              <mat-autocomplete
                (optionSelected)="ownerSelect($event)"
                #autoOwner="matAutocomplete"
              >
                <mat-option
                  *ngFor="let x of filteredUsers"
                  [value]="x.fullname"
                >
                  {{ x.fullname | titlecase }} -
                  <span style="font-size: 15px; font-style: italic">{{
                    x.type == 0 ? "User" : x.type == 1 ? "Employee" : "Visitor"
                  }}</span>
                  -
                  <span style="font-size: 12px; font-style: italic">{{
                    getCustomPhoneNumber(x.mobile)
                  }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </mat-grid-tile> -->
          <mat-grid-tile>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Tag Name</mat-label>
              <input
                matInput
                formControlName="eventOwnerName"
                [matAutocomplete]="autoOwner"
              />
              <mat-autocomplete
                (optionSelected)="ownerSelect($event.option.value)"
                #autoOwner="matAutocomplete"
                autoActiveFirstOption
              >
                <mat-option
                  *ngFor="let owner of filteredUsers | async"
                  [value]="owner"
                >
                  {{ owner.fullname | titlecase }} -
                  <span style="font-size: 15px; font-style: italic">{{
                    owner.type == 0
                      ? "User"
                      : owner.type == 1
                      ? "Employee"
                      : owner.type == 3
                      ? "New Tag"
                      : "Visitor"
                  }}</span>
                  -
                  <span style="font-size: 12px; font-style: italic">{{
                    getCustomPhoneNumber(owner.mobile)
                  }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </mat-grid-tile>

          <mat-grid-tile
            ><mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Tag Email </mat-label>
              <input
                matInput
                formControlName="eventOwnerEmail"
              /> </mat-form-field
          ></mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field
              class="custom-padding-fix"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <ngx-mat-intl-tel-input
                #phoneInput
                [enablePlaceholder]="true"
                [required]="false"
                [preferredCountries]="['in']"
                [enableSearch]="true"
                name="phone"
                formControlName="eventOwnerPhone"
                [inputPlaceholder]="'Tag Number'"
                [label]="'Owner Number'"
                [maxlength]="15"
                [disabled]="isOwnerSelected"
              ></ngx-mat-intl-tel-input>
              <mat-error
                *ngIf="incidentManualEvent.controls['eventOwnerPhone']?.errors?.['validatePhoneNumber']
              &&
              false"
                ><i>Enter valid number</i>
              </mat-error>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="notify-host-button">
              <button (click)="onClickOpenMap()" mat-raised-button>
                Select Location
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="notify-host-button">
              <button
                [disabled]="incidentManualEvent.invalid"
                (click)="createManualEvent()"
                mat-raised-button
              >
                Notify
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
  </section>
  <mat-divider></mat-divider>
</section>
<ng-template #CreateManualEventDialog>
  <h2 matDialogTitle>Generating Manual Incident</h2>
  <mat-dialog-content>
    <div>
      <b><i> Please wait! Notifying the participating members</i></b>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <mat-spinner></mat-spinner>
  </mat-dialog-actions>
</ng-template>
<ng-template #RefreshingIncident>
  <h2 matDialogTitle>Refreshing Incident Data</h2>
  <mat-dialog-content><i>Please wait!</i> </mat-dialog-content>
  <mat-dialog-actions>
    <mat-spinner></mat-spinner>
  </mat-dialog-actions>
</ng-template>
